<template>
  <hr :class="`w-full border-solid border-t-${validHeight} border-grey-divider-subdued`" />
</template>

<script lang="ts">
export default {
  name: 'HorizontalDivider',
  props: {
    height: {
      type: Number,
      default: 1,
      validator(value) {
        return value === null || (typeof value === 'number' && value > 0);
      },
    },
  },
  computed: {
    validHeight(): number {
      return this.height > 0 ? this.height : 1;
    },
  },
};
</script>
